import React, { FC } from 'react'

const VerifiedBadge: FC = () => (
  <span aria-label="Phone verified" className="checkout-contact-flow__verified-badge" role="img">
    <svg aria-hidden="true" className="checkout-contact-flow__verified-icon" fill="none" viewBox="0 0 20 20">
      <g className="checkout-contact-flow__verified-circle-group">
        <circle cx="10" cy="10" r="8.5" />
      </g>
      <g className="checkout-contact-flow__verified-check-group">
        <path d="M6.2 10.4 8.8 13 13.8 8" />
      </g>
    </svg>
  </span>
)

export default VerifiedBadge
